// src/utils/constants.js
export const API_URL = process.env.REACT_APP_API_URL;

export const SERVICE_TYPES = {
  SESSION: 'Session',
  INITIAL_ASSESSMENT: 'Initial Assessment',
  TWELVE_WEEK_REVIEW: '12 Week Review',
  SONGWRITING_ASSESSMENT: 'Songwriting Assessment'
};


export const SESSION_LENGTHS = [
  { value: 15, label: '15 minutes' },
  { value: 30, label: '30 minutes' },
  { value: 45, label: '45 minutes' },
  { value: 60, label: '60 minutes' },
  { value: 75, label: '75 minutes' },
  { value: 90, label: '90 minutes' }
];

export const MILITARY_BRANCHES = [
  'Army',
  'Navy',
  'Air Force',
  'Marine Corps',
  'Coast Guard',
  'Space Force',
  'National Guard',
  'Reserves'
];

export const MILITARY_STATUS = [
  'Active Duty',
  'Retired',
  'Veteran',
  'Reserves',
  'National Guard',
  'Separated'
];

export const ERROR_MESSAGES = {
  DEFAULT: 'An error occurred. Please try again.',
  AUTH_REQUIRED: 'Authentication required. Please log in.',
  SESSION_EXPIRED: 'Your session has expired. Please log in again.',
  NETWORK_ERROR: 'Network error. Please check your connection.',
  FORBIDDEN: 'You do not have permission to perform this action.',
  NOT_FOUND: 'The requested resource was not found.',
  SERVER_ERROR: 'Server error. Please try again later.'
};

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  LOGIN_SUCCESS: '/login-success',
  LOGIN_ERROR: '/login-error'
};

// Regular expressions for validation
export const VALIDATION_PATTERNS = {
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  PHONE: /^\+?1?\d{9,15}$/,
  PASSWORD: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/
};

// Configuration for API requests
export const API_CONFIG = {
  TIMEOUT: 10000, // 10 seconds
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000 // 1 second
};